import { render, staticRenderFns } from "./perubahanShift.vue?vue&type=template&id=1918e145"
import script from "./perubahanShift.vue?vue&type=script&lang=js"
export * from "./perubahanShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports